// extracted by mini-css-extract-plugin
export default {"cls1":"VeloCardButton_cls1__AqwLu","cls2":"VeloCardButton_cls2__uiYkg VeloCardButton_cls1__AqwLu"};